module.exports = __webpack_public_path__ + "img/ico-social.b5f54493.svg";